import { render, staticRenderFns } from "./entity-structure.vue?vue&type=template&id=2f82024e&scoped=true&"
import script from "./entity-structure.ts?vue&type=script&lang=ts&"
export * from "./entity-structure.ts?vue&type=script&lang=ts&"
import style0 from "./entity-structure.scss?vue&type=style&index=0&id=2f82024e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82024e",
  null
  
)

export default component.exports